// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*--------- Contents -----------

1. Reset css
2. Navbar Styling
3. Hero Section Styling
4. Button Styling 
5. Features section Styling
6. Product Tour Styling
7. Video Feature Styling 
8. FAQ Section Styling
9. Pricing Section Styling
10. f-box Styling
11. Clients Section Styling
12. Footer Styling 
13. All media queries
-------------------------------*/

/*----- 1. Reset.css -----*/

/* http://meyerweb.com/eric/tools/css/reset/
   v2.0 | 20110126
   License: none (public domain)
*/

html, body, div, span, applet, object, iframe,
h1, h2, h3, h4, h5, h6, p, blockquote, pre,
a, abbr, acronym, address, big, cite, code,
del, dfn, em, img, ins, kbd, q, s, samp,
small, strike, strong, sub, sup, tt, var,
b, u, i, center,
dl, dt, dd, ol, ul, li,
fieldset, form, label, legend,
table, caption, tbody, tfoot, thead, tr, th, td,
article, aside, canvas, details, embed,
figure, figcaption, footer, header, hgroup,
menu, nav, output, ruby, section, summary,
time, mark, audio, video {
	margin: 0;
	padding: 0;
	border: 0;
	font-size: 100%;
	font: inherit;
	vertical-align: baseline;
}
/* HTML5 display-role reset for older browsers */
article, aside, details, figcaption, figure,
footer, header, hgroup, menu, nav, section {
	display: block;
}
body {
	line-height: 1;
}
ol, ul {
	list-style: none;
}
blockquote, q {
	quotes: none;
}
blockquote:before, blockquote:after,
q:before, q:after {
	content: '';
	content: none;
}
table {
	border-collapse: collapse;
	border-spacing: 0;
}


/* --- Common Styles ---*/

h1, h2, h3, h4, h5, h6 {
	font-family: 'Montserrat';
  font-size: 16px;
}

p {
	font-family: 'Montserrat';
	font-size: 14px;
}

p a {
	color:#bbbbbb;
}

p a:hover {
	color:#ffffff;
}

.cplp_sup {
	font-size: 7px;
	vertical-align: super;
}

ion-icon {
	--ionicon-strike-width: 16px;
	font-size: 32px;
	margin-bottom: -10px;
	padding-right: 10px;
}

/*----- Helper Classes -----*/

html * {
	text-rendering: optimizeLegibility !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}

*, *:after, *:before {
  box-sizing: border-box;
}

.nopadding {
	padding: 0;
}

.nomargin {
	margin: 0 !important;
}

.custom-padding {
	padding-left: 10px;
	padding-right: 10px;
}

.bg-color {
	background: #f8faff !important;
}

#loading {
   width: 100%;
   height: 100%;
   top: 0px;
   left: 0px;
   position: fixed;
   opacity: 1;
   background-color: #F2F2F2;
   z-index: 9999;
   text-align: center;
}

#loading-image {
	display: inline;
    top: 40%;
    position: relative;
  z-index: 9999;
}

.error-message {
	color: #FF3333;
	font-family: "Montserrat";
	margin-top: 5px;
}

.success-message {
	color:#33cc33;
	font-family: "Montserrat";
	margin-top: 5px;
}


/*----------------------------------------------------------
--------------- 2. Nav Bar Styling -------------------------
----------------------------------------------------------*/

.navbar {
  font-family: "Montserrat";
	padding-top: 10px;
	padding-bottom: 10px;
	background-color: #ffffff !important;
	transition: 0.5s all ease;
}

.navbar .navbar-brand {
	font-size: 1.1rem;
	font-weight: 600;
	color: #563D7C;
}

.navbar .navbar-toggler {
	border: none;
}

.navbar span.navbar-toggler-icon::before {
	outline: none;
}

.navbar .navbar-toggler:focus {
	outline: none;
}

.navbar-nav {
	text-align: center;
	margin-top: 15px; /* For Safari 3.1 to 6.0 */
	transition: 0.5s all ease;
}

.navbar-nav .nav-item {
	margin-right: 0;
	margin-top: 1.5rem;
	font-size: 12px;
	font-weight: 400;
	text-transform: capitalize;
	color: #2e7eed;
	border:2px solid #2e7eed;
	border-radius:100px;
	padding:0 10px;
}

.navbar-nav .nav-item:hover {
	border:2px solid #2e7eed;
	background: #2e7eed;
    color: #FFFFFF;
}

.navbar-nav .nav-item a:hover {
	color: #FFFFFF;
}

.navbar-nav .nav-item .nav-link {
	color: #2e7eed;
	font-weight: 500;
	font-size: 12px;
	text-transform: uppercase;
}



@media only screen and (max-width: 768px) {

	.navbar {
		background: rgba(255, 255, 255, 0.99) !important;
		padding-top: 10px;
		padding-bottom: 10px;
	}
}

@media only screen and (min-width: 240px) {

.navbar.past-main {
	background-color: rgba(255, 255, 255, 0.99) !important;
	box-shadow: 0 1px 5px 0 rgba(96, 96, 96, 0.3);
}

.navbar.effect-main {
  transition: all 0.3s;
}


.navbar.past-main .nav-item .nav-link {
	font-weight: 500;
}

.header-logo {
	max-width:240px;
}

.cplp_phone-icon {
	margin-right:5px;
}

.cplp_nav-phone {
	font-size:15px;
	width:60%;
	text-align:right
}


.cplp_navbar-right {
    display: flex!important;
    flex-basis: auto;
    flex-grow: 1;
    align-items: center;
}

/*----------------------------------------------------------
--------------- 3. Hero Home Styling  ----------------------
----------------------------------------------------------*/

.centered {
	float: none !important;
  margin-left: auto !important;
  margin-right: auto !important;
}


.cplp_home-2 h4 {
	font-family: 'Open Sans';
	font-size: 24px;
	font-weight: 700;
	color: #eeeeee;
	text-transform: uppercase;
	line-height: 1.2;
	letter-spacing: 2px;
	margin-bottom: 20px;
}

.cplp_home-2 img {
	margin-top: 50px;
}

.cplp_home-2 h1 {
	font-size: 28px;
	font-weight: 700;
	color: #364655;
	color: #FFF;
	line-height: 1.2;
	letter-spacing: -1px;
}

.cplp_home-2 p {
	font-size: 16px;
	font-weight: 300;
	color: #627382;
	color: #FFF;
	line-height: 1.6;
	letter-spacing: 1px;
	margin-top: 20px;
}

.cplp_home-2 {
	padding: 100px 0 50px 0 !important;
	background: #2e7eed;
	background-image: url('cpw-ms-hero-bg.f2885a9cc74f8f48.jpg');
	background-repeat: no-repeat;
	background-size: cover;
}

.cplp_home-2 .cplp_hero-content {
	text-align: center;
}

.cplp_home-2 .intro-block {
	padding: 15px;
}

.cplp_home-2 .subform {
	padding-top: 50px;
}


.cplp_home-2 .hero-split {
	width: 100%;
}

.cplp_hero-bullets {
	font-family: 'Montserrat';
	font-size: 18px;
	color: #ffffff;
	line-height: 1.6em;
	margin-top: 15px;
	letter-spacing: 0.5px;
}

.cplp_hero-bullets a {
	color:#ddd;
}

.cplp_hero-content .hero-quote {
	font-family: 'Montserrat';
	font-size: 12px;
	color: #ffffff;
	line-height: 1.6em;
}

.cplp_hero-content .hero-quote-author {
	font-weight: 500;
	font-size: 13px;
	margin-top:5px;
}

.cplp_hero-imagery {
	text-align:right;
}

.cplp_hero-imagery .aws-logo {
	max-width:150px;
	margin-top:10px;
	padding-right:25px;
}

/*----------------------------------------------------------
--------------- 4. Button Styling -------------------------
----------------------------------------------------------*/

.cplp_btn-action {
	padding: 10px 24px;
	border: 2px solid;
	border-radius: 100px;
	box-shadow: 0 3px 15px 0 rgba(0,0,0,.25);
	font-family: 'Montserrat';
	font-size: 12px;
	font-weight: bold;
	text-transform: uppercase;
	letter-spacing: 1px;
	margin: 25px 0 0 0;
	transition: 0.2s;
}

.cplp_btn-action-primary {
	background: #ffffff;
	border-color: #ffffff;
	color: #6c63ff;

}

.cplp_btn-action-primary:hover {
	color: #6c63ff;
	border-color: #ffffff;
	background: #ffffff;
	transform: translateY(-2px);
}

.cplp_btn-action-primary:focus {
	color: #6c63ff;
}

.cplp_btn-action-primary-onwhite {
	background: #ffffff;
	border-color: #6c63ff;
	color: #6c63ff;
}

.cplp_btn-action-primary-onwhite:hover {
	color: #6c63ff;
	border-color: #6c63ff;
	background: #ffffff;
	transform: translateY(-2px);
}

.cplp_btn-action-primary-onwhite:focus {
	color: #6c63ff;
}

.cplp_btn-action-secondary {
	background: none;
	border-color: #ffffff;
	color: #ffffff;
	margin-left: 10px;
}

.cplp_btn-action-secondary:hover {
	color: #ffffff;
	border-color: #ffffff;
	background: none;
	transform: translateY(-2px);
}

.cplp_btn-action-secondary:focus {
	color: #FFFFFF;
}

.cplp_btn-action-buy {
	/* background: #6c63ff;
	border-color: #6c63ff; */
	color: #ffffff;
	text-transform: uppercase;
    background-color: #d2962f;
}

/* .cplp_btn-action-buy:hover {
	color: #6c63ff;
	border-color: #6c63ff;
	background: #ffffff;
	-webkit-transform: translateY(-2px);
	-moz-transform: translateY(-2px);
	transform: translateY(-2px);
} */

/* .cplp_btn-action-buy:focus {
	color: #6c63ff;
} */

/*---------------------------------------------------------------
------------------ 5. Features Styling  -------------------------
---------------------------------------------------------------*/


.features {
	padding: 50px 0 50px 0;
}

.flex-split {
	padding: 25px 0 25px 0;
}

.features .row, .app-feature .row, .flex-split .row, .hero .row {
    display: flex;
    flex-wrap: wrap;
    margin-right: -15px;
    margin-left: -15px;
	}

.align-center {
    align-items: center!important;
}

.features .feature-img {
	margin-bottom: 50px;
}

.features .feature-content h2 {
	font-size: 24px;
	font-weight: 500;
	line-height: 1.2;
	margin-bottom: 20px;
}

.features .feature-content p {
	font-size: 15px;
	font-weight: 400;
	line-height: 1.6;
	color: #898989;
}

.features hr {
	margin: 3em auto;
	border-color: #FFF;
	background-color: transparent;
}

.features-row-img-right {
}

.features-row-img-left {
	padding-top:100px;
}

.features-img-left {
	padding-left:0;
}


/*------------------------------------------------------
----------------- 6. Product Tour Styling --------------
------------------------------------------------------*/


.cplp_product-tour {
	padding: 100px 0 100px 0;
	overflow: hidden;
}

.cplp_product-tour .cplp_tour-img {
	transform: translateX(0);
}

.cplp_tour-list  {
	padding-top: 0;
	overflow: hidden;
}

.cplp_tour-list ul {
	list-style-type: none;
	overflow: hidden;
}

.cplp_tour-list ul li {
	margin-bottom: 30px;
	overflow: hidden;
}

.cplp_product-tour .cplp_tour-icon {
	float: left;
	width: 20%;
}

.cplp_product-tour .cplp_tour-text {
	float: right;
	width: 80%;
}

.cplp_product-tour .cplp_tour-text h3 {
	font-size: 21px;
  font-weight: 500;
  line-height: 1.2;
  margin-bottom: 10px;
}

.cplp_product-tour .cplp_tour-text p {
	font-size: 15px;
  font-weight: 400;
  line-height: 1.6;
  color: #444444;
}

/*-----------------------------------------------------
------------ 6.1. Benefits Section styling --- -------------
-----------------------------------------------------*/

.cplp_benefits .cplp_benefits-text h1 {
	font-size: 25px;
  font-weight: 500;
  line-height: 1.2;
  margin-bottom: 10px;
  text-align: center;
}

.cplp_benefits .cplp_benefits-text p {
	font-size: 19px;
  font-weight: 400;
  line-height: 1.6;
  color: #444444;
}

.cplp_benefits .cplp_benefits-list {
	margin-top:20px;
}

.cplp_benefits a:hover {
  color:#444;
  }

/*-----------------------------------------------------
------------ 6.2. Testimonials Section styling --- -------------
-----------------------------------------------------*/

.cplp_testimonials .cplp_testimonials-text-intro {
	margin-top:0;
}

.cplp_testimonials .cplp_testimonials-text {
	margin-top:30px;
}

.cplp_testimonials-text-intro h1 {
  font-size: 28px;
  font-weight: 600;
  color: #364655;
  line-height: 1.2;
  margin-bottom: 50px;
  text-align: center;
}

.cplp_testimonials .cplp_testimonials-text p {
	font-size: 19px;
  font-weight: 400;
  line-height: 1.6;
  color: #444444;
}

.cplp_testimonials .cplp_testimonials-text .cplp_testimonial-single-author {
	font-weight:500;
}

.cplp_testimonials a:hover {
  color:#444;
}

.cplp_testimonial-single {
	margin-top:5px;
}
  
/*-----------------------------------------------------
------------ 7. Video Feature styling --- -------------
-----------------------------------------------------*/
.vid-cover {
	position: relative;
	overflow: hidden;
	background: #252525;
	border-radius: 6px;
	box-shadow: 0 23px 40px rgba(0, 0, 0, 0.2);
	z-index: 3;
	margin-top: 60px;
	margin-bottom: 30px;
}

.vid-cover.active .vid-icon.active,
.vid-cover.active .vid-holder.active {
  opacity: 0 !important;
  pointer-events: none;
}




/*-----------------------------------------------------
------------ 8. FAQ styling ---------------------------
-----------------------------------------------------*/


.cplp_faq-feature {
	padding: 50px 0 50px 0;
	background: #FFFFFF;
}

.cplp_faq-feature .col-md-6, .cplp_faq-feature .col-sm-8 {
	margin: 0 auto;
	float: none;
}

.cplp_faq-feature h1 {
	font-family: 'Montserrat';
	font-size: 34px;
	font-weight: 300;
	line-height: 1.2;
	letter-spacing: -1px;
}

.cplp_faq-feature h6 {
	font-family: 'Montserrat';
	font-size: 14px;
	font-weight: 400;
	line-height: 1.4;
	letter-spacing: 0;
}

.cplp_faq-feature h6 b {
	font-weight: 600;
}

.cplp_faq-feature h6 span a {
	font-family: 'Montserrat';
	font-size: 14px;
	font-weight: 400;
	color: #387ed1;
	text-transform: capitalize;
	text-decoration: underline;
	line-height: 1.2;
}

.cplp_faq-intro {
	padding-bottom: 0px;
}

.cplp_faq-intro h1 {
	font-size: 28px;
	color: #364655;
	font-weight: 600;
	line-height: 1.4;
	margin-bottom: 20px;
}

.cplp_faq-intro p {
	font-size: 14px;
	color: #364655;
	font-weight: 300;
	line-height: 1.4;
	letter-spacing: 1px;
	margin-top: 10px;
	margin-bottom: 50px;
}

.faq {
	padding: 50px 0 50px 0;
	background: #FFFFFF;
}


.faq .faq-intro h1 {
	font-size: 28px;
	color: #364655;
	font-weight: 600;
	line-height: 1.4;
	margin-bottom: 20px;
}

.faq .faq-intro p {
	font-size: 16px;
	font-weight: 300;
	line-height: 1.4;
}

.faq h2 {
	font-size: 17px;
	font-weight: 500;
	color: #222;
	line-height: 1.4;
	margin-top: 20px;
	margin-bottom: 20px;
}

.faq p {
	font-size: 16px;
	font-weight: 400;
	line-height: 1.6;
	letter-spacing: 0.5px;
	color: #222;
	margin-top: 10px;
	padding-bottom: 40px;
}


.accordion h2 {
	margin: 5px 0;
}

.accordion h2 i {
	margin-right: 15px;
}

.accordion p a {
	color: #0000aa;
}

.accordion-box {
	padding: 20px 20px 50px 20px !important;
}

/*-----------------------------------------------------
------------ 9. Pricing Tables Styling ----------------
-----------------------------------------------------*/


.cplp_pricing-section {
	width: 100%;
	height: 100%;
	padding-top: 50px;
	padding-bottom: 75px;
	background: #FFFFFF;
}

.cplp_pricing-intro {
	padding-bottom: 0px;
}

.cplp_pricing-intro h1 {
	font-size: 28px;
	color: #364655;
	font-weight: 600;
	line-height: 1.4;
	margin-bottom: 20px;
}

.cplp_pricing-intro p {
	font-size: 14px;
	color: #364655;
	font-weight: 300;
	line-height: 1.4;
	letter-spacing: 1px;
	margin-top: 10px;
	margin-bottom: 50px;
}

.cplp_pricing-details {
	padding: 0 0 0 0;
}

.cplp_pricing-section .cplp_table-left, .cplp_pricing-section .cplp_table-right {
	padding: 0 0 50px 0;
	margin: 0 auto;
	background-color: #FFFFFF;
	box-shadow: 0px 0px 80px 0px rgba(0,0,0,.1);
	border: transparent;
	max-width: 400px;
}

.cplp_pricing-section .cplp_table-most-popular {
	background: #555!important;
}

.cplp_table-left .icon, .cplp_table-right .icon {
	padding: 50px 50px 40px 50px;
}

.cplp_table-left .icon img, .cplp_table-right .icon img {
	width: 60px;
	height: 60px;
	margin: 0 auto;
}

.cplp_table-left .cplp_pricing-details span, .cplp_table-right .cplp_pricing-details span {
	display: inline-block;
	font-family: 'Montserrat';
	font-size: 38px;
	font-weight: 600;
	color: #808080;
	margin-bottom: 5px;
}

.cplp_table-most-popular .cplp_pricing-details span, 
.cplp_table-most-popular .cplp_pricing-details p,
.cplp_table-most-popular .cplp_pricing-details h2 {
	color: #eee!important;
}

.cplp_pricing-ribbon {
	position: absolute;
	top: 115px;
	right: 10px;
	background: #fdfe80;
	padding: 10px 15px;
	box-shadow: 0 3px 15px 0 rgba(0,0,0,.25);
}

.cplp_pricing-ribbon h3 {
	color: #222;
	font-weight:500;
	font-size:14px;
	text-transform:uppercase;
}

.cplp_pricing-ribbon-arrow {
	position: absolute;
	top: 115px;
	right: 112px;
  width: 0; 
  height: 0; 
  border-top: 17px solid transparent;
  border-bottom: 17px solid transparent; 
  border-right: 10px solid #fdfe80; 
}

.cplp_table-left .cplp_pricing-details h2, .cplp_table-right .cplp_pricing-details h2 {
	font-size: 21px;
	font-weight: 500;
	color: #505050;
	margin-bottom: 30px;
}

.cplp_table-left .cplp_pricing-details p, .cplp_table-right .cplp_pricing-details p {
	font-size: 14px;
	font-weight: 300;
	color: #505050;
	letter-spacing: 0.75px;
	line-height: 1.4;
}

.cplp_table-left .cplp_pricing-details ul, .cplp_table-right .cplp_pricing-details ul {
	margin-top: 30px;
	margin-bottom: 30px;
	padding: 0;
}


.cplp_table-left .cplp_pricing-details li, .cplp_table-right .cplp_pricing-details li {
	font-family: 'Montserrat';
	font-size: 16px;
	font-weight: 400;
	color: #505050;
	line-height: 1.4;
	margin-bottom: 10px;
}

.cplp_pricing-section .cplp_table-left:hover, .cplp_pricing-section .cplp_table-right:hover {
	box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);
	transition: 0.3s;
}

.cplp_pricing-section .cplp_table-left, .cplp_pricing-section .cplp_table-right {
	margin-top: 20px;
	background: #fafafa;
	min-height: 575px;
}
/*
.cplp_pricing-section .cplp_table-center {
	margin-top: 0;
}
*/
.cplp_pricing-section, .cplp_faq-feature, .faq {
	background: #eef2f5;
}

.cplp_core-price {
	margin: auto;
}

.cplp_buy-price {
	color: #000000 !important;
}

.cplp_pricing-trial {
	margin-top:15px;
	color:#999999;
}

.cplp_pricing-trial a {
	color:#333333;
	text-decoration: underline;
	font-weight:400;
}

.cplp_pricing-trial a:hover {
	color:#6c63ff;
}

.cplp_pricing-link {
	margin-top:15px;
}

.cplp_pricing-link  a{
	color:#6c63ff;
}

.cplp_pricing-link  a:hover{
	color:#333;
}

/* The slider switch */
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 34px;
  margin: 0 5px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.switch-label-sub {
	font-size: 12px;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #6c63ff;
  transition: .4s;
}

.slider:before {
  position: absolute;
  content: "";
  height: 26px;
  width: 26px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: .4s;
}


input:focus + .slider {
  box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
  transform: translateX(26px);
}


.slider.round {
  border-radius: 34px;
}

.slider.round:before {
  border-radius: 50%;
}

.monthly-price-base, .monthly-price-full, .monthly-price-pro {
	display:none;
}

.annual-price-terms {
	font-size: 11px!important;
	font-weight: 400!important;
	letter-spacing: 0.5px!important;
	margin-top:5px!important;
	color:#000!important;
}

.cplp_pricing-feature-txt {
	font-family: 'Montserrat', Sans-serif!important;
	font-size:16px!important;
	/* font-weight: 400!important; */
	color: #505050!important;
	line-height: 1.4!important;
	margin-bottom: 10px!important;
	letter-spacing: 0.5px;
}

.cplp_pricing-features {
	margin-top:25px;
	min-height: 368px;
}

.cplp_pricing-features .row{
	clear: both;
}

.cplp_pricing-tier h2 {
	color:#fff!important;
	padding-top: 20px;
	padding-bottom: 20px;
}

.cplp_pricing-tier-1 {
	background: #3598dc;
}

.cplp_pricing-tier-2 {
	background: #e7505a;;
}

.cplp_pricing-tier-3 {
	background: #8e44ad;
}

.cplp_pricing-summary {
	margin-top:15px;
	padding: 0 20px;
}




/*-----------------------------------------------------
------------ 10. f-box Section Styling ----------------
-----------------------------------------------------*/


.cplp_f-box {
  width: 100%;
  padding-top: 50px;
  padding-bottom: 50px;
	background: #eef2f5;
  background-size: cover;
  background-attachment: fixed;
}

.cplp_f-box-single {
  background: #fff;
  padding: 1em 1em 0.5em 1em;
	margin-top: 1em;
	margin-bottom: 1em;
	border-radius: 5px;
	border: 1px solid rgba(0, 0, 0, .05);
  transition: 0.3s;
}

.cplp_f-box-single:hover {
  background: #FFF;
}

.cplp_f-box-content h3 {
  font-size: 18px;
  letter-spacing: 0;
  color: #364655;
  font-weight: 500;
}

.cplp_f-box-content p {
  font-size: 14px;
  color: #616771;
  line-height: 1.8;
  padding: 1.2em;
}

@media only screen and (min-width: 801px) and (max-width: 991px) {
  .cplp_f-box-single {
    padding: 1em;
  }
}

@media only screen and (max-width: 767px) {
  .cplp_f-box-single {
    margin-bottom: 1em;
  }
}

@media only screen and (max-width:576px) {
	.navigation .container {
		margin: 0;
	}
}

/*-----------------------------------------------------
------------ 11. Client Section Styling --------------
-----------------------------------------------------*/


.cplp_client-section {
	background-color: #eef2f5;
	padding: 25px 25px;
	border: 1px solid #eef2f5;
}

.cplp_clients .cplp_single img {
	width: 180px;
	opacity: 0.75;
}

.cplp_clients {
	text-align: center;
}

.cplp_clients-intro h1{
	margin-bottom:20px;
	margin-top:5px;
	font-size:28px;
	color: #364655;
	font-weight: 600;
}


/*-------------- 8. Review Section Styling ------------*/

.section-r {
	margin-top: 50px;
	margin-bottom:25px;
}

.review-section {
	padding: 0 0 0 0;
	box-shadow: 0px 5px 50px 0px rgba(0,0,0,.1);
	margin-bottom: 50px;
	border-radius: 10px;
}

.review-section .review-text {
	max-width: 85%;
	margin: 0 auto;
}

.review-section .review-text p {
	font-size: 18px;
	font-weight: 400;
	line-height: 1.6;
	letter-spacing: 0.5px;
	color: #333333;
	margin-bottom: 10px;
}

.review-section .review-text h3 {
	font-size: 18px;
	font-weight: 500;
	color: #000000;
	margin-bottom: 10px;
	margin-top: 20px;
}

.review-section .review-text h4 {
	font-size: 14px;
	font-weight: 400;
	color: #000000;
}

.review-single {
	text-align: center;
	padding: 50px 0 25px 0;
}

.review-single img {
	width: 180px !important;
	margin: 0 auto;
	margin-bottom: 20px;
}

.review-text .ion {
	display: inline-block;
	margin-top: 20px;
  font-size: 14px;
  color: #ff8000;
}

.owl-theme .owl-dots {
    display: none !important;
}


/*--------------------------------------------------------------
---------------12. Footer Styling  -----------------------
--------------------------------------------------------------*/


.cplp_footer {
	padding: 50px 0 50px 0;
	background: #333333;
}

.cplp_footer h2 {
	font-size: 18px;
	font-weight: 500;
	color: #FFFFFF;
	margin-bottom: 10px;
}

.cplp_footer p {
	font-size: 13px;
	font-weight: 400;
	color: #364655;
	color: #FFF;
	letter-spacing: 0;
	line-height: 1.4;
	max-width: 320px;
	margin-bottom: 10px;
}

.cplp_footer .cplp_f-mail {
	margin: 5px 5px 0 0;
	font-family: 'Montserrat';
	font-size: 13px;
	letter-spacing: 0;
	color: #364655;
	color: #D8D8D8;
	line-height: 1.6;
}

.cplp_footer .cplp_f-legal {
	margin: 5px 5px 0 10px;
	font-family: 'Montserrat';
	font-size: 15px;
	letter-spacing: 0;
	color: #bbbbbb;
	line-height: 1.6;
}

.cplp_footer .cplp_f-legals {
	font-size: 15px;
	color: #bbbbbb;
	padding-top:20px;
}

.cplp_footer .cplp_footer-logo {
	margin-bottom:10px;
}

/* ------------Back-to-Top ----------------------*/

.back-to-top {
	background: rgba(68, 176, 255, 0.5);
	margin: 0;
	position: fixed;
	bottom: 30px;
	right: 30px;
	width: 40px;
	height: 40px;
	border-radius: 3px;
	z-index: 90;
	display: none;
	text-decoration: none;
	color: #0E1729;
	box-shadow:0 5px 10px rgba(0, 0, 0, .3);
}

.back-to-top i {
	position: relative;
	left: 12px;
	top: 5px;
	font-size: 24px;
	color: #FFFFFF;
	transition: 200ms;
}

.back-to-top:hover {
	background: rgba(68, 176, 255, 0.8);
  color: #FFFFFF;
}

.back-to-top:hover i {
	top: 6px;
}

.back-to-top:focus {
    color: #FFFFFF;
}



/*-----------------------------------------------------------------
------------------ 13. All Media Queries  -------------------------
-----------------------------------------------------------------*/

@media only screen and (min-width: 767px) {

	.navbar-nav {
			margin-top: 0;
		}

	.navbar-nav .nav-item {
		margin-top: 0;
		margin-right: 15px;
	  font-size: 0.85rem;
	  font-weight: 400;
	}

	.cplp_home-2 {
		padding: 100px 0 60px 0 !important;
	}

	.cplp_home-2 .col-sm-5 {
		flex: 0 0 50%;
		max-width: 50%;
	}

	.features {
		padding: 75px 0 50px 0;
	}

	.features .col-sm-5 {
		flex: 0 0 41.666667%;
		max-width: 41.666667%;
	}

	.features .col-sm-7 {
		flex: 0 0 58.333333%;
		max-width: 58.333333%;
	}

	.features .feature-img {
		margin-bottom: 0;
	}

	.cplp_product-tour .cplp_tour-intro {
		padding: 0;
	}

	.cplp_product-tour .cplp_tour-img {
		transform: translateX(120px);
	}

	.cplp_product-tour .cplp_tour-img {
		transform: translateX(0);
		max-width: 100%;
	}

	.cplp_clients .cplp_single img {
		width: 180px;
		opacity: 0.75;
	}
	
	.vid-cover iframe {
	width: 100%;
	min-height: 380px;
}

}


@media only screen and (min-width: 1024px) {

	.cplp_home-2 img {
		margin-top: 0;
	}

	.cplp_home-2 .cplp_hero-content {
		text-align: left;
	}

	.cplp_product-tour .cplp_tour-intro h1 {
		font-size: 28px;
	}

	.cplp_product-tour .cplp_tour-img {
		transform: translateX(80px);
		max-width: 100%;
	}

}

@media only screen and (max-width: 992px) {

	.cplp_nav-phone {
		display:none;
	}

	.cplp_pricing-ribbon {
		top: 115px;
		right: 150px;
	}
	
	.cplp_pricing-ribbon-arrow {
		top: 115px;
		right: 252px;
	}

}

@media only screen and (max-width: 550px) {

	.cplp_pricing-ribbon {
		top: 115px;
		right: 40px!important;
	}
	
	.cplp_pricing-ribbon-arrow {
		top: 115px;
		right: 142px!important;
	}

}

@media only screen and (max-width: 350px) {
	
	.vid-cover iframe {
		width: 100%;
		min-height: 165px;
	}
	
}

@media only screen and (min-width: 351px) {
	
	.vid-cover iframe {
		width: 100%;
		min-height: 260px;
	}
	
}

@media only screen and (min-width: 761px) {
	
	.vid-cover iframe {
		width: 100%;
		min-height: 375px;
	}
	
}

@media only screen and (min-width: 975px) {
	
	.vid-cover iframe {
		width: 100%;
		min-height: 298px;
	}
	
}

@media only screen and (min-width: 1182px) {
	
	.vid-cover iframe {
		width: 100%;
		min-height: 355px;
	}
	
}

@media only screen and (max-width: 1200px) {
	
	.cplp_pricing-feature-txt {
		font-size: 12px!important;
	}

	.cplp_nav-phone {
		font-size: 13px;
	}
	
}


@media only screen and (max-width: 767px) {

	.cplp_product-tour .cplp_tour-img {
		transform: translateX(0);
		max-width: 100%;
	}
	
	.cplp_navbar-right {
		padding-bottom: 30px;
	}
	
	.cplp_home-2 {
		padding: 150px 0 50px 0 !important;
	}
	
	.navbar-nav {
		flex-direction: row;
		margin-top:0;
	}
	
	.navbar-nav .nav-item {
		margin-right: 7px;
		margin-top: 0;
	}
	
	.navbar-nav .nav-item  .nav-link {
		font-size: 10px;
	}
	
	.navbar .navbar-toggler {
		display: none;
	}
	
	.navbar .cplp_navbar-right {
		padding-bottom: 0;
	}
	
	.header-logo {
		max-width:150px;
	}
	
	.cplp_pricing-ribbon {
		top: 115px;
		right: 65px;
	}
	
	.cplp_pricing-ribbon-arrow {
		top: 115px;
		right: 167px;
	}
}
 /*----------------------------------------------------------
--------------- 3. Login Page Styling  ----------------------
----------------------------------------------------------*/

    .cplp_login-body {
        background: #2e7eed;
    }

    .cplp_login-section h4 {
        font-family: 'Open Sans';
        font-size: 24px;
        font-weight: 700;
        color: #eeeeee;
        text-transform: uppercase;
        line-height: 1.2;
        letter-spacing: 2px;
        margin-bottom: 20px;
    }

    .cplp_login-section h1 {
        font-size: 28px;
        font-weight: 700;
        color: #364655;
        /* color: #FFF; */
        line-height: 1.2;
        letter-spacing: -1px;
    }

    .cplp_login-section p {
        font-size: 16px;
        font-weight: 300;
        color: #627382;
        /* color: #FFF; */
        line-height: 1.6;
        letter-spacing: 1px;
        margin-top: 20px;
    }

    .cplp_login-section {
        font-family: 'Open Sans';
        padding: 100px 0 50px 0 !important;
        background:rgb(245, 250, 255);
    }

    .cplp_login-intro h1 {
        margin-bottom: 10px;
    }

    .cplp_login-intro h2 {
        font-size: 22px;
        font-weight: 700;
        color: #364655;
        /* color: #FFF; */
        line-height: 1.2;
        letter-spacing: -1px;
        margin-bottom: 30px;
    }

    .cplp_login-section .cplp_login-intro {
        text-align: center;
    }

    .cplp_login-section {
        width: 100%;
    }

    .cplp_login-submit {
        text-align: center;
        margin-top: 20px;
    }

    .cplp_login-remember {
        text-align: left;
        margin-top: 20px;
        color: #fff;
    }

    .cplp_login-forgot {
        text-align: right;
        margin-top: 20px;
        color: #364655;
    }

    .cplp_login-create {
        text-align: center;
        margin-top: 30px;
        color: #364655;
    }

        .cplp_login-forgot a, .cplp_login-activate a, .cplp_login-create a {
            color: #364655;
        }

    .cplp_login-footer {
        text-align: center;
    }

        .cplp_login-footer p {
            font-family: 'Open Sans';
            font-size: 12px;
            margin-top: 10px;
        }

    .cplp_login-divider {
        color: #364655;
        border-top: 1px solid rgba(255,255,255,.2);
        margin: 50px 0;
    }

    .cplp_login-logo {
        max-width: 150px;
    }

}`, "",{"version":3,"sources":["webpack://./src/assets/anonymouspage/css/style.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;gCAegC;;AAEhC,2BAA2B;;AAE3B;;;CAGC;;AAED;;;;;;;;;;;;;CAaC,SAAS;CACT,UAAU;CACV,SAAS;CACT,eAAe;CACf,aAAa;CACb,wBAAwB;AACzB;AACA,gDAAgD;AAChD;;CAEC,cAAc;AACf;AACA;CACC,cAAc;AACf;AACA;CACC,gBAAgB;AACjB;AACA;CACC,YAAY;AACb;AACA;;CAEC,WAAW;CACX,aAAa;AACd;AACA;CACC,yBAAyB;CACzB,iBAAiB;AAClB;;;AAGA,yBAAyB;;AAEzB;CACC,yBAAyB;EACxB,eAAe;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;AAChB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;CACd,qBAAqB;AACtB;;AAEA;CACC,4BAA4B;CAC5B,eAAe;CACf,oBAAoB;CACpB,mBAAmB;AACpB;;AAEA,6BAA6B;;AAE7B;CACC,6CAA6C;EAC5C,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;CACC,mCAAmC;CACnC,kCAAkC;AACnC;;AAEA;EAGE,sBAAsB;AACxB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;GACG,WAAW;GACX,YAAY;GACZ,QAAQ;GACR,SAAS;GACT,eAAe;GACf,UAAU;GACV,yBAAyB;GACzB,aAAa;GACb,kBAAkB;AACrB;;AAEA;CACC,eAAe;IACZ,QAAQ;IACR,kBAAkB;EACpB,aAAa;AACf;;AAEA;CACC,cAAc;CACd,yBAAyB;CACzB,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,yBAAyB;CACzB,eAAe;AAChB;;;AAGA;;2DAE2D;;AAE3D;EACE,yBAAyB;CAC1B,iBAAiB;CACjB,oBAAoB;CACpB,oCAAoC;CAEpC,yBAAyB;AAC1B;;AAEA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,gBAAgB,EACmB,0BAA0B;CAC7D,yBAAyB;AAC1B;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,eAAe;CACf,gBAAgB;CAChB,0BAA0B;CAC1B,cAAc;CACd,wBAAwB;CACxB,mBAAmB;CACnB,cAAc;AACf;;AAEA;CACC,wBAAwB;CACxB,mBAAmB;IAChB,cAAc;AAClB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,cAAc;CACd,gBAAgB;CAChB,eAAe;CACf,yBAAyB;AAC1B;;;;AAIA;;CAEC;EACC,gDAAgD;EAChD,iBAAiB;EACjB,oBAAoB;CACrB;AACD;;AAEA;;AAEA;CACC,sDAAsD;CAGtD,6CAA6C;AAC9C;;AAEA;EAEE,oBAAoB;AACtB;;;AAGA;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,cAAc;CACd,SAAS;CACT;AACD;;;AAGA;IAGI,uBAAuB;IAEvB,gBAAgB;IAEhB,YAAY;IAEZ,mBAAmB;AACvB;;AAEA;;2DAE2D;;AAE3D;CACC,sBAAsB;EACrB,4BAA4B;EAC5B,6BAA6B;AAC/B;;;AAGA;CACC,wBAAwB;CACxB,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,yBAAyB;CACzB,gBAAgB;CAChB,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,WAAW;CACX,gBAAgB;CAChB,oBAAoB;AACrB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,WAAW;CACX,gBAAgB;CAChB,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,kCAAkC;CAClC,mBAAmB;CACnB,4DAAqD;CACrD,4BAA4B;CAC5B,sBAAsB;AACvB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,iBAAiB;AAClB;;;AAGA;CACC,WAAW;AACZ;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,cAAc;CACd,kBAAkB;CAClB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,UAAU;AACX;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,cAAc;CACd,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,eAAe;CACf,cAAc;AACf;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kBAAkB;AACnB;;AAEA;;2DAE2D;;AAE3D;CACC,kBAAkB;CAClB,iBAAiB;CACjB,oBAAoB;CACpB,wCAAwC;CACxC,yBAAyB;CACzB,eAAe;CACf,iBAAiB;CACjB,yBAAyB;CACzB,mBAAmB;CACnB,kBAAkB;CAGlB,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;CACnB,qBAAqB;CACrB,cAAc;;AAEf;;AAEA;CACC,cAAc;CACd,qBAAqB;CACrB,mBAAmB;CAGnB,2BAA2B;AAC5B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,mBAAmB;CACnB,qBAAqB;CACrB,cAAc;AACf;;AAEA;CACC,cAAc;CACd,qBAAqB;CACrB,mBAAmB;CAGnB,2BAA2B;AAC5B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,qBAAqB;CACrB,cAAc;CACd,iBAAiB;AAClB;;AAEA;CACC,cAAc;CACd,qBAAqB;CACrB,gBAAgB;CAGhB,2BAA2B;AAC5B;;AAEA;CACC,cAAc;AACf;;AAEA;CACC;yBACwB;CACxB,cAAc;CACd,yBAAyB;IACtB,yBAAyB;AAC7B;;AAEA;;;;;;;GAOG;;AAEH;;GAEG;;AAEH;;gEAEgE;;;AAGhE;CACC,sBAAsB;AACvB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;IAII,aAAa;IAGb,eAAe;IACf,mBAAmB;IACnB,kBAAkB;CACrB;;AAED;IAII,6BAA6B;AACjC;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;CAClB,6BAA6B;AAC9B;;AAEA;AACA;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,cAAc;AACf;;;AAGA;;uDAEuD;;;AAGvD;CACC,wBAAwB;CACxB,gBAAgB;AACjB;;AAEA;CACC,wBAAwB;AACzB;;AAEA;CACC,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,qBAAqB;CACrB,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,WAAW;CACX,UAAU;AACX;;AAEA;CACC,YAAY;CACZ,UAAU;AACX;;AAEA;CACC,eAAe;EACd,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;CACC,eAAe;EACd,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;sDAEsD;;AAEtD;CACC,eAAe;EACd,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;CACC,eAAe;EACd,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;EACE,UAAU;EACV;;AAEF;;sDAEsD;;AAEtD;CACC,YAAY;AACb;;AAEA;CACC,eAAe;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;CACC,eAAe;EACd,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;CACC,cAAc;AACf;;AAEA;;sDAEsD;AACtD;CACC,kBAAkB;CAClB,gBAAgB;CAChB,mBAAmB;CACnB,kBAAkB;CAClB,0CAA0C;CAC1C,UAAU;CACV,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;;EAEE,qBAAqB;EACrB,oBAAoB;AACtB;;;;;AAKA;;sDAEsD;;;AAGtD;CACC,sBAAsB;CACtB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,WAAW;AACZ;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,oBAAoB;AACrB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,0BAA0B;CAC1B,0BAA0B;CAC1B,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,gBAAgB;CAChB,mBAAmB;CACnB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,sBAAsB;CACtB,mBAAmB;AACpB;;;AAGA;CACC,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,WAAW;CACX,gBAAgB;CAChB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,qBAAqB;CACrB,WAAW;CACX,gBAAgB;CAChB,oBAAoB;AACrB;;;AAGA;CACC,aAAa;AACd;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,uCAAuC;AACxC;;AAEA;;sDAEsD;;;AAGtD;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,oBAAoB;CACpB,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,gBAAgB;CAChB,gBAAgB;CAChB,mBAAmB;CACnB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,mBAAmB;CACnB,cAAc;CACd,yBAAyB;CACzB,2CAA2C;CAC3C,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,WAAW;CACX,YAAY;CACZ,cAAc;AACf;;AAEA;CACC,qBAAqB;CACrB,yBAAyB;CACzB,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,kBAAkB;AACnB;;AAEA;;;CAGC,qBAAqB;AACtB;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,WAAW;CACX,mBAAmB;CACnB,kBAAkB;CAClB,wCAAwC;AACzC;;AAEA;CACC,WAAW;CACX,eAAe;CACf,cAAc;CACd,wBAAwB;AACzB;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,YAAY;EACX,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,sBAAsB;CACtB,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,UAAU;AACX;;;AAGA;CACC,yBAAyB;CACzB,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,yCAAyC;CAIzC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;CAChB,mBAAmB;CACnB,iBAAiB;AAClB;AACA;;;;CAIC;AACD;CACC,mBAAmB;AACpB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,eAAe;CACf,aAAa;AACd;;AAEA;CACC,aAAa;CACb,0BAA0B;CAC1B,eAAe;AAChB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,UAAU;AACX;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;CACC,eAAe;AAChB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB;EAEzB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EAEvB,eAAe;AACjB;;;AAGA;EACE,2BAA2B;AAC7B;;AAEA;EAGE,2BAA2B;AAC7B;;;AAGA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;CACC,YAAY;AACb;;AAEA;CACC,yBAAyB;CACzB,0BAA0B;CAC1B,+BAA+B;CAC/B,wBAAwB;CACxB,oBAAoB;AACrB;;AAEA;CACC,+CAA+C;CAC/C,wBAAwB;CACxB,gCAAgC;CAChC,wBAAwB;CACxB,0BAA0B;CAC1B,6BAA6B;CAC7B,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;CACC,oBAAoB;CACpB,iBAAiB;CACjB,oBAAoB;AACrB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,eAAe;AAChB;;;;;AAKA;;sDAEsD;;;AAGtD;EACE,WAAW;EACX,iBAAiB;EACjB,oBAAoB;CACrB,mBAAmB;EAClB,sBAAsB;EACtB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;CAC3B,eAAe;CACf,kBAAkB;CAClB,kBAAkB;CAClB,oCAAoC;EAGnC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;CACC;EACC,SAAS;CACV;AACD;;AAEA;;sDAEsD;;;AAGtD;CACC,yBAAyB;CACzB,kBAAkB;CAClB,yBAAyB;AAC1B;;AAEA;CACC,YAAY;CACZ,aAAa;AACd;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,cAAc;CACd,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;;AAGA,wDAAwD;;AAExD;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;CAChB,2CAA2C;CAC3C,mBAAmB;CACnB,mBAAmB;AACpB;;AAEA;CACC,cAAc;CACd,cAAc;AACf;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,gBAAgB;CAChB,qBAAqB;CACrB,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,mBAAmB;CACnB,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;AACf;;AAEA;CACC,kBAAkB;CAClB,sBAAsB;AACvB;;AAEA;CACC,uBAAuB;CACvB,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,qBAAqB;CACrB,gBAAgB;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;IACI,wBAAwB;AAC5B;;;AAGA;;+DAE+D;;;AAG/D;CACC,sBAAsB;CACtB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB,cAAc;CACd,WAAW;CACX,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;CACnB,yBAAyB;CACzB,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,sBAAsB;CACtB,yBAAyB;CACzB,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,kBAAkB;AACnB;;AAEA,kDAAkD;;AAElD;CACC,mCAAmC;CACnC,SAAS;CACT,eAAe;CACf,YAAY;CACZ,WAAW;CACX,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,WAAW;CACX,aAAa;CACb,qBAAqB;CACrB,cAAc;CACd,uCAAuC;AACxC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,QAAQ;CACR,eAAe;CACf,cAAc;CAId,iBAAiB;AAClB;;AAEA;CACC,mCAAmC;EAClC,cAAc;AAChB;;AAEA;CACC,QAAQ;AACT;;AAEA;IACI,cAAc;AAClB;;;;AAIA;;kEAEkE;;AAElE;;CAEC;GACE,aAAa;EACd;;CAED;EACC,aAAa;EACb,kBAAkB;GACjB,kBAAkB;GAClB,gBAAgB;CAClB;;CAEA;EACC,kCAAkC;CACnC;;CAEA;EAIC,aAAa;EACb,cAAc;CACf;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EAIC,oBAAoB;EACpB,qBAAqB;CACtB;;CAEA;EAIC,oBAAoB;EACpB,qBAAqB;CACtB;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,UAAU;CACX;;CAEA;EACC,4BAA4B;CAC7B;;CAEA;EACC,wBAAwB;EACxB,eAAe;CAChB;;CAEA;EACC,YAAY;EACZ,aAAa;CACd;;CAEA;CACA,WAAW;CACX,iBAAiB;AAClB;;AAEA;;;AAGA;;CAEC;EACC,aAAa;CACd;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,2BAA2B;EAC3B,eAAe;CAChB;;AAED;;AAEA;;CAEC;EACC,YAAY;CACb;;CAEA;EACC,UAAU;EACV,YAAY;CACb;;CAEA;EACC,UAAU;EACV,YAAY;CACb;;AAED;;AAEA;;CAEC;EACC,UAAU;EACV,qBAAqB;CACtB;;CAEA;EACC,UAAU;EACV,sBAAsB;CACvB;;AAED;;AAEA;;CAEC;EACC,WAAW;EACX,iBAAiB;CAClB;;AAED;;AAEA;;CAEC;EACC,WAAW;EACX,iBAAiB;CAClB;;AAED;;AAEA;;CAEC;EACC,WAAW;EACX,iBAAiB;CAClB;;AAED;;AAEA;;CAEC;EACC,WAAW;EACX,iBAAiB;CAClB;;AAED;;AAEA;;CAEC;EACC,WAAW;EACX,iBAAiB;CAClB;;AAED;;AAEA;;CAEC;EACC,yBAAyB;CAC1B;;CAEA;EACC,eAAe;CAChB;;AAED;;;AAGA;;CAEC;EACC,wBAAwB;EACxB,eAAe;CAChB;;CAEA;EACC,oBAAoB;CACrB;;CAEA;EACC,kCAAkC;CACnC;;CAEA;EACC,mBAAmB;EACnB,YAAY;CACb;;CAEA;EACC,iBAAiB;EACjB,aAAa;CACd;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,aAAa;CACd;;CAEA;EACC,iBAAiB;CAClB;;CAEA;EACC,eAAe;CAChB;;CAEA;EACC,UAAU;EACV,WAAW;CACZ;;CAEA;EACC,UAAU;EACV,YAAY;CACb;AACD;CACC;;2DAE0D;;IAEvD;QACI,mBAAmB;IACvB;;IAEA;QACI,wBAAwB;QACxB,eAAe;QACf,gBAAgB;QAChB,cAAc;QACd,yBAAyB;QACzB,gBAAgB;QAChB,mBAAmB;QACnB,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,cAAc;QACd,iBAAiB;QACjB,gBAAgB;QAChB,oBAAoB;IACxB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,cAAc;QACd,iBAAiB;QACjB,gBAAgB;QAChB,mBAAmB;QACnB,gBAAgB;IACpB;;IAEA;QACI,wBAAwB;QACxB,kCAAkC;QAClC,6BAA6B;IACjC;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,cAAc;QACd,iBAAiB;QACjB,gBAAgB;QAChB,oBAAoB;QACpB,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,gBAAgB;QAChB,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,iBAAiB;QACjB,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,kBAAkB;QAClB,gBAAgB;QAChB,cAAc;IAClB;;QAEI;YACI,cAAc;QAClB;;IAEJ;QACI,kBAAkB;IACtB;;QAEI;YACI,wBAAwB;YACxB,eAAe;YACf,gBAAgB;QACpB;;IAEJ;QACI,cAAc;QACd,0CAA0C;QAC1C,cAAc;IAClB;;IAEA;QACI,gBAAgB;IACpB;;AAEJ","sourcesContent":["/*--------- Contents -----------\n\n1. Reset css\n2. Navbar Styling\n3. Hero Section Styling\n4. Button Styling \n5. Features section Styling\n6. Product Tour Styling\n7. Video Feature Styling \n8. FAQ Section Styling\n9. Pricing Section Styling\n10. f-box Styling\n11. Clients Section Styling\n12. Footer Styling \n13. All media queries\n-------------------------------*/\n\n/*----- 1. Reset.css -----*/\n\n/* http://meyerweb.com/eric/tools/css/reset/\n   v2.0 | 20110126\n   License: none (public domain)\n*/\n\nhtml, body, div, span, applet, object, iframe,\nh1, h2, h3, h4, h5, h6, p, blockquote, pre,\na, abbr, acronym, address, big, cite, code,\ndel, dfn, em, img, ins, kbd, q, s, samp,\nsmall, strike, strong, sub, sup, tt, var,\nb, u, i, center,\ndl, dt, dd, ol, ul, li,\nfieldset, form, label, legend,\ntable, caption, tbody, tfoot, thead, tr, th, td,\narticle, aside, canvas, details, embed,\nfigure, figcaption, footer, header, hgroup,\nmenu, nav, output, ruby, section, summary,\ntime, mark, audio, video {\n\tmargin: 0;\n\tpadding: 0;\n\tborder: 0;\n\tfont-size: 100%;\n\tfont: inherit;\n\tvertical-align: baseline;\n}\n/* HTML5 display-role reset for older browsers */\narticle, aside, details, figcaption, figure,\nfooter, header, hgroup, menu, nav, section {\n\tdisplay: block;\n}\nbody {\n\tline-height: 1;\n}\nol, ul {\n\tlist-style: none;\n}\nblockquote, q {\n\tquotes: none;\n}\nblockquote:before, blockquote:after,\nq:before, q:after {\n\tcontent: '';\n\tcontent: none;\n}\ntable {\n\tborder-collapse: collapse;\n\tborder-spacing: 0;\n}\n\n\n/* --- Common Styles ---*/\n\nh1, h2, h3, h4, h5, h6 {\n\tfont-family: 'Montserrat';\n  font-size: 16px;\n}\n\np {\n\tfont-family: 'Montserrat';\n\tfont-size: 14px;\n}\n\np a {\n\tcolor:#bbbbbb;\n}\n\np a:hover {\n\tcolor:#ffffff;\n}\n\n.cplp_sup {\n\tfont-size: 7px;\n\tvertical-align: super;\n}\n\nion-icon {\n\t--ionicon-strike-width: 16px;\n\tfont-size: 32px;\n\tmargin-bottom: -10px;\n\tpadding-right: 10px;\n}\n\n/*----- Helper Classes -----*/\n\nhtml * {\n\ttext-rendering: optimizeLegibility !important;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nbody {\n\t-webkit-font-smoothing: antialiased;\n\t-moz-osx-font-smoothing: grayscale;\n}\n\n*, *:after, *:before {\n  -webkit-box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n\n.nopadding {\n\tpadding: 0;\n}\n\n.nomargin {\n\tmargin: 0 !important;\n}\n\n.custom-padding {\n\tpadding-left: 10px;\n\tpadding-right: 10px;\n}\n\n.bg-color {\n\tbackground: #f8faff !important;\n}\n\n#loading {\n   width: 100%;\n   height: 100%;\n   top: 0px;\n   left: 0px;\n   position: fixed;\n   opacity: 1;\n   background-color: #F2F2F2;\n   z-index: 9999;\n   text-align: center;\n}\n\n#loading-image {\n\tdisplay: inline;\n    top: 40%;\n    position: relative;\n  z-index: 9999;\n}\n\n.error-message {\n\tcolor: #FF3333;\n\tfont-family: \"Montserrat\";\n\tmargin-top: 5px;\n}\n\n.success-message {\n\tcolor:#33cc33;\n\tfont-family: \"Montserrat\";\n\tmargin-top: 5px;\n}\n\n\n/*----------------------------------------------------------\n--------------- 2. Nav Bar Styling -------------------------\n----------------------------------------------------------*/\n\n.navbar {\n  font-family: \"Montserrat\";\n\tpadding-top: 10px;\n\tpadding-bottom: 10px;\n\tbackground-color: #ffffff !important;\n\t-webkit-transition: 0.5s all ease;\n\ttransition: 0.5s all ease;\n}\n\n.navbar .navbar-brand {\n\tfont-size: 1.1rem;\n\tfont-weight: 600;\n\tcolor: #563D7C;\n}\n\n.navbar .navbar-toggler {\n\tborder: none;\n}\n\n.navbar span.navbar-toggler-icon::before {\n\toutline: none;\n}\n\n.navbar .navbar-toggler:focus {\n\toutline: none;\n}\n\n.navbar-nav {\n\ttext-align: center;\n\tmargin-top: 15px;\n\t-webkit-transition: 0.5s all ease; /* For Safari 3.1 to 6.0 */\n\ttransition: 0.5s all ease;\n}\n\n.navbar-nav .nav-item {\n\tmargin-right: 0;\n\tmargin-top: 1.5rem;\n\tfont-size: 12px;\n\tfont-weight: 400;\n\ttext-transform: capitalize;\n\tcolor: #2e7eed;\n\tborder:2px solid #2e7eed;\n\tborder-radius:100px;\n\tpadding:0 10px;\n}\n\n.navbar-nav .nav-item:hover {\n\tborder:2px solid #2e7eed;\n\tbackground: #2e7eed;\n    color: #FFFFFF;\n}\n\n.navbar-nav .nav-item a:hover {\n\tcolor: #FFFFFF;\n}\n\n.navbar-nav .nav-item .nav-link {\n\tcolor: #2e7eed;\n\tfont-weight: 500;\n\tfont-size: 12px;\n\ttext-transform: uppercase;\n}\n\n\n\n@media only screen and (max-width: 768px) {\n\n\t.navbar {\n\t\tbackground: rgba(255, 255, 255, 0.99) !important;\n\t\tpadding-top: 10px;\n\t\tpadding-bottom: 10px;\n\t}\n}\n\n@media only screen and (min-width: 240px) {\n\n.navbar.past-main {\n\tbackground-color: rgba(255, 255, 255, 0.99) !important;\n\t-webkit-box-shadow: 0 1px 5px 0 rgba(96, 96, 96, 0.3);\n\t-moz-box-shadow: 0 1px 5px 0 rgba(96, 96, 96, 0.3);\n\tbox-shadow: 0 1px 5px 0 rgba(96, 96, 96, 0.3);\n}\n\n.navbar.effect-main {\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n}\n\n\n.navbar.past-main .nav-item .nav-link {\n\tfont-weight: 500;\n}\n\n.header-logo {\n\tmax-width:240px;\n}\n\n.cplp_phone-icon {\n\tmargin-right:5px;\n}\n\n.cplp_nav-phone {\n\tfont-size:15px;\n\twidth:60%;\n\ttext-align:right\n}\n\n\n.cplp_navbar-right {\n    display: -webkit-box!important;\n    display: -ms-flexbox!important;\n    display: flex!important;\n    -ms-flex-preferred-size: auto;\n    flex-basis: auto;\n    -webkit-box-flex: 1;\n    flex-grow: 1;\n    -webkit-box-align: center;\n    align-items: center;\n}\n\n/*----------------------------------------------------------\n--------------- 3. Hero Home Styling  ----------------------\n----------------------------------------------------------*/\n\n.centered {\n\tfloat: none !important;\n  margin-left: auto !important;\n  margin-right: auto !important;\n}\n\n\n.cplp_home-2 h4 {\n\tfont-family: 'Open Sans';\n\tfont-size: 24px;\n\tfont-weight: 700;\n\tcolor: #eeeeee;\n\ttext-transform: uppercase;\n\tline-height: 1.2;\n\tletter-spacing: 2px;\n\tmargin-bottom: 20px;\n}\n\n.cplp_home-2 img {\n\tmargin-top: 50px;\n}\n\n.cplp_home-2 h1 {\n\tfont-size: 28px;\n\tfont-weight: 700;\n\tcolor: #364655;\n\tcolor: #FFF;\n\tline-height: 1.2;\n\tletter-spacing: -1px;\n}\n\n.cplp_home-2 p {\n\tfont-size: 16px;\n\tfont-weight: 300;\n\tcolor: #627382;\n\tcolor: #FFF;\n\tline-height: 1.6;\n\tletter-spacing: 1px;\n\tmargin-top: 20px;\n}\n\n.cplp_home-2 {\n\tpadding: 100px 0 50px 0 !important;\n\tbackground: #2e7eed;\n\tbackground-image: url(\"../images/cpw-ms-hero-bg.jpg\");\n\tbackground-repeat: no-repeat;\n\tbackground-size: cover;\n}\n\n.cplp_home-2 .cplp_hero-content {\n\ttext-align: center;\n}\n\n.cplp_home-2 .intro-block {\n\tpadding: 15px;\n}\n\n.cplp_home-2 .subform {\n\tpadding-top: 50px;\n}\n\n\n.cplp_home-2 .hero-split {\n\twidth: 100%;\n}\n\n.cplp_hero-bullets {\n\tfont-family: 'Montserrat';\n\tfont-size: 18px;\n\tcolor: #ffffff;\n\tline-height: 1.6em;\n\tmargin-top: 15px;\n\tletter-spacing: 0.5px;\n}\n\n.cplp_hero-bullets a {\n\tcolor:#ddd;\n}\n\n.cplp_hero-content .hero-quote {\n\tfont-family: 'Montserrat';\n\tfont-size: 12px;\n\tcolor: #ffffff;\n\tline-height: 1.6em;\n}\n\n.cplp_hero-content .hero-quote-author {\n\tfont-weight: 500;\n\tfont-size: 13px;\n\tmargin-top:5px;\n}\n\n.cplp_hero-imagery {\n\ttext-align:right;\n}\n\n.cplp_hero-imagery .aws-logo {\n\tmax-width:150px;\n\tmargin-top:10px;\n\tpadding-right:25px;\n}\n\n/*----------------------------------------------------------\n--------------- 4. Button Styling -------------------------\n----------------------------------------------------------*/\n\n.cplp_btn-action {\n\tpadding: 10px 24px;\n\tborder: 2px solid;\n\tborder-radius: 100px;\n\tbox-shadow: 0 3px 15px 0 rgba(0,0,0,.25);\n\tfont-family: 'Montserrat';\n\tfont-size: 12px;\n\tfont-weight: bold;\n\ttext-transform: uppercase;\n\tletter-spacing: 1px;\n\tmargin: 25px 0 0 0;\n\t-webkit-transition: 0.2s;\n\t-moz-transition: 0.2s;\n\ttransition: 0.2s;\n}\n\n.cplp_btn-action-primary {\n\tbackground: #ffffff;\n\tborder-color: #ffffff;\n\tcolor: #6c63ff;\n\n}\n\n.cplp_btn-action-primary:hover {\n\tcolor: #6c63ff;\n\tborder-color: #ffffff;\n\tbackground: #ffffff;\n\t-webkit-transform: translateY(-2px);\n\t-moz-transform: translateY(-2px);\n\ttransform: translateY(-2px);\n}\n\n.cplp_btn-action-primary:focus {\n\tcolor: #6c63ff;\n}\n\n.cplp_btn-action-primary-onwhite {\n\tbackground: #ffffff;\n\tborder-color: #6c63ff;\n\tcolor: #6c63ff;\n}\n\n.cplp_btn-action-primary-onwhite:hover {\n\tcolor: #6c63ff;\n\tborder-color: #6c63ff;\n\tbackground: #ffffff;\n\t-webkit-transform: translateY(-2px);\n\t-moz-transform: translateY(-2px);\n\ttransform: translateY(-2px);\n}\n\n.cplp_btn-action-primary-onwhite:focus {\n\tcolor: #6c63ff;\n}\n\n.cplp_btn-action-secondary {\n\tbackground: none;\n\tborder-color: #ffffff;\n\tcolor: #ffffff;\n\tmargin-left: 10px;\n}\n\n.cplp_btn-action-secondary:hover {\n\tcolor: #ffffff;\n\tborder-color: #ffffff;\n\tbackground: none;\n\t-webkit-transform: translateY(-2px);\n\t-moz-transform: translateY(-2px);\n\ttransform: translateY(-2px);\n}\n\n.cplp_btn-action-secondary:focus {\n\tcolor: #FFFFFF;\n}\n\n.cplp_btn-action-buy {\n\t/* background: #6c63ff;\n\tborder-color: #6c63ff; */\n\tcolor: #ffffff;\n\ttext-transform: uppercase;\n    background-color: #d2962f;\n}\n\n/* .cplp_btn-action-buy:hover {\n\tcolor: #6c63ff;\n\tborder-color: #6c63ff;\n\tbackground: #ffffff;\n\t-webkit-transform: translateY(-2px);\n\t-moz-transform: translateY(-2px);\n\ttransform: translateY(-2px);\n} */\n\n/* .cplp_btn-action-buy:focus {\n\tcolor: #6c63ff;\n} */\n\n/*---------------------------------------------------------------\n------------------ 5. Features Styling  -------------------------\n---------------------------------------------------------------*/\n\n\n.features {\n\tpadding: 50px 0 50px 0;\n}\n\n.flex-split {\n\tpadding: 25px 0 25px 0;\n}\n\n.features .row, .app-feature .row, .flex-split .row, .hero .row {\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-flex-wrap: wrap;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    margin-right: -15px;\n    margin-left: -15px;\n\t}\n\n.align-center {\n    -webkit-box-align: center!important;\n    -webkit-align-items: center!important;\n    -ms-flex-align: center!important;\n    align-items: center!important;\n}\n\n.features .feature-img {\n\tmargin-bottom: 50px;\n}\n\n.features .feature-content h2 {\n\tfont-size: 24px;\n\tfont-weight: 500;\n\tline-height: 1.2;\n\tmargin-bottom: 20px;\n}\n\n.features .feature-content p {\n\tfont-size: 15px;\n\tfont-weight: 400;\n\tline-height: 1.6;\n\tcolor: #898989;\n}\n\n.features hr {\n\tmargin: 3em auto;\n\tborder-color: #FFF;\n\tbackground-color: transparent;\n}\n\n.features-row-img-right {\n}\n\n.features-row-img-left {\n\tpadding-top:100px;\n}\n\n.features-img-left {\n\tpadding-left:0;\n}\n\n\n/*------------------------------------------------------\n----------------- 6. Product Tour Styling --------------\n------------------------------------------------------*/\n\n\n.cplp_product-tour {\n\tpadding: 100px 0 100px 0;\n\toverflow: hidden;\n}\n\n.cplp_product-tour .cplp_tour-img {\n\ttransform: translateX(0);\n}\n\n.cplp_tour-list  {\n\tpadding-top: 0;\n\toverflow: hidden;\n}\n\n.cplp_tour-list ul {\n\tlist-style-type: none;\n\toverflow: hidden;\n}\n\n.cplp_tour-list ul li {\n\tmargin-bottom: 30px;\n\toverflow: hidden;\n}\n\n.cplp_product-tour .cplp_tour-icon {\n\tfloat: left;\n\twidth: 20%;\n}\n\n.cplp_product-tour .cplp_tour-text {\n\tfloat: right;\n\twidth: 80%;\n}\n\n.cplp_product-tour .cplp_tour-text h3 {\n\tfont-size: 21px;\n  font-weight: 500;\n  line-height: 1.2;\n  margin-bottom: 10px;\n}\n\n.cplp_product-tour .cplp_tour-text p {\n\tfont-size: 15px;\n  font-weight: 400;\n  line-height: 1.6;\n  color: #444444;\n}\n\n/*-----------------------------------------------------\n------------ 6.1. Benefits Section styling --- -------------\n-----------------------------------------------------*/\n\n.cplp_benefits .cplp_benefits-text h1 {\n\tfont-size: 25px;\n  font-weight: 500;\n  line-height: 1.2;\n  margin-bottom: 10px;\n  text-align: center;\n}\n\n.cplp_benefits .cplp_benefits-text p {\n\tfont-size: 19px;\n  font-weight: 400;\n  line-height: 1.6;\n  color: #444444;\n}\n\n.cplp_benefits .cplp_benefits-list {\n\tmargin-top:20px;\n}\n\n.cplp_benefits a:hover {\n  color:#444;\n  }\n\n/*-----------------------------------------------------\n------------ 6.2. Testimonials Section styling --- -------------\n-----------------------------------------------------*/\n\n.cplp_testimonials .cplp_testimonials-text-intro {\n\tmargin-top:0;\n}\n\n.cplp_testimonials .cplp_testimonials-text {\n\tmargin-top:30px;\n}\n\n.cplp_testimonials-text-intro h1 {\n  font-size: 28px;\n  font-weight: 600;\n  color: #364655;\n  line-height: 1.2;\n  margin-bottom: 50px;\n  text-align: center;\n}\n\n.cplp_testimonials .cplp_testimonials-text p {\n\tfont-size: 19px;\n  font-weight: 400;\n  line-height: 1.6;\n  color: #444444;\n}\n\n.cplp_testimonials .cplp_testimonials-text .cplp_testimonial-single-author {\n\tfont-weight:500;\n}\n\n.cplp_testimonials a:hover {\n  color:#444;\n}\n\n.cplp_testimonial-single {\n\tmargin-top:5px;\n}\n  \n/*-----------------------------------------------------\n------------ 7. Video Feature styling --- -------------\n-----------------------------------------------------*/\n.vid-cover {\n\tposition: relative;\n\toverflow: hidden;\n\tbackground: #252525;\n\tborder-radius: 6px;\n\tbox-shadow: 0 23px 40px rgba(0, 0, 0, 0.2);\n\tz-index: 3;\n\tmargin-top: 60px;\n\tmargin-bottom: 30px;\n}\n\n.vid-cover.active .vid-icon.active,\n.vid-cover.active .vid-holder.active {\n  opacity: 0 !important;\n  pointer-events: none;\n}\n\n\n\n\n/*-----------------------------------------------------\n------------ 8. FAQ styling ---------------------------\n-----------------------------------------------------*/\n\n\n.cplp_faq-feature {\n\tpadding: 50px 0 50px 0;\n\tbackground: #FFFFFF;\n}\n\n.cplp_faq-feature .col-md-6, .cplp_faq-feature .col-sm-8 {\n\tmargin: 0 auto;\n\tfloat: none;\n}\n\n.cplp_faq-feature h1 {\n\tfont-family: 'Montserrat';\n\tfont-size: 34px;\n\tfont-weight: 300;\n\tline-height: 1.2;\n\tletter-spacing: -1px;\n}\n\n.cplp_faq-feature h6 {\n\tfont-family: 'Montserrat';\n\tfont-size: 14px;\n\tfont-weight: 400;\n\tline-height: 1.4;\n\tletter-spacing: 0;\n}\n\n.cplp_faq-feature h6 b {\n\tfont-weight: 600;\n}\n\n.cplp_faq-feature h6 span a {\n\tfont-family: 'Montserrat';\n\tfont-size: 14px;\n\tfont-weight: 400;\n\tcolor: #387ed1;\n\ttext-transform: capitalize;\n\ttext-decoration: underline;\n\tline-height: 1.2;\n}\n\n.cplp_faq-intro {\n\tpadding-bottom: 0px;\n}\n\n.cplp_faq-intro h1 {\n\tfont-size: 28px;\n\tcolor: #364655;\n\tfont-weight: 600;\n\tline-height: 1.4;\n\tmargin-bottom: 20px;\n}\n\n.cplp_faq-intro p {\n\tfont-size: 14px;\n\tcolor: #364655;\n\tfont-weight: 300;\n\tline-height: 1.4;\n\tletter-spacing: 1px;\n\tmargin-top: 10px;\n\tmargin-bottom: 50px;\n}\n\n.faq {\n\tpadding: 50px 0 50px 0;\n\tbackground: #FFFFFF;\n}\n\n\n.faq .faq-intro h1 {\n\tfont-size: 28px;\n\tcolor: #364655;\n\tfont-weight: 600;\n\tline-height: 1.4;\n\tmargin-bottom: 20px;\n}\n\n.faq .faq-intro p {\n\tfont-size: 16px;\n\tfont-weight: 300;\n\tline-height: 1.4;\n}\n\n.faq h2 {\n\tfont-size: 17px;\n\tfont-weight: 500;\n\tcolor: #222;\n\tline-height: 1.4;\n\tmargin-top: 20px;\n\tmargin-bottom: 20px;\n}\n\n.faq p {\n\tfont-size: 16px;\n\tfont-weight: 400;\n\tline-height: 1.6;\n\tletter-spacing: 0.5px;\n\tcolor: #222;\n\tmargin-top: 10px;\n\tpadding-bottom: 40px;\n}\n\n\n.accordion h2 {\n\tmargin: 5px 0;\n}\n\n.accordion h2 i {\n\tmargin-right: 15px;\n}\n\n.accordion p a {\n\tcolor: #0000aa;\n}\n\n.accordion-box {\n\tpadding: 20px 20px 50px 20px !important;\n}\n\n/*-----------------------------------------------------\n------------ 9. Pricing Tables Styling ----------------\n-----------------------------------------------------*/\n\n\n.cplp_pricing-section {\n\twidth: 100%;\n\theight: 100%;\n\tpadding-top: 50px;\n\tpadding-bottom: 75px;\n\tbackground: #FFFFFF;\n}\n\n.cplp_pricing-intro {\n\tpadding-bottom: 0px;\n}\n\n.cplp_pricing-intro h1 {\n\tfont-size: 28px;\n\tcolor: #364655;\n\tfont-weight: 600;\n\tline-height: 1.4;\n\tmargin-bottom: 20px;\n}\n\n.cplp_pricing-intro p {\n\tfont-size: 14px;\n\tcolor: #364655;\n\tfont-weight: 300;\n\tline-height: 1.4;\n\tletter-spacing: 1px;\n\tmargin-top: 10px;\n\tmargin-bottom: 50px;\n}\n\n.cplp_pricing-details {\n\tpadding: 0 0 0 0;\n}\n\n.cplp_pricing-section .cplp_table-left, .cplp_pricing-section .cplp_table-right {\n\tpadding: 0 0 50px 0;\n\tmargin: 0 auto;\n\tbackground-color: #FFFFFF;\n\tbox-shadow: 0px 0px 80px 0px rgba(0,0,0,.1);\n\tborder: transparent;\n\tmax-width: 400px;\n}\n\n.cplp_pricing-section .cplp_table-most-popular {\n\tbackground: #555!important;\n}\n\n.cplp_table-left .icon, .cplp_table-right .icon {\n\tpadding: 50px 50px 40px 50px;\n}\n\n.cplp_table-left .icon img, .cplp_table-right .icon img {\n\twidth: 60px;\n\theight: 60px;\n\tmargin: 0 auto;\n}\n\n.cplp_table-left .cplp_pricing-details span, .cplp_table-right .cplp_pricing-details span {\n\tdisplay: inline-block;\n\tfont-family: 'Montserrat';\n\tfont-size: 38px;\n\tfont-weight: 600;\n\tcolor: #808080;\n\tmargin-bottom: 5px;\n}\n\n.cplp_table-most-popular .cplp_pricing-details span, \n.cplp_table-most-popular .cplp_pricing-details p,\n.cplp_table-most-popular .cplp_pricing-details h2 {\n\tcolor: #eee!important;\n}\n\n.cplp_pricing-ribbon {\n\tposition: absolute;\n\ttop: 115px;\n\tright: 10px;\n\tbackground: #fdfe80;\n\tpadding: 10px 15px;\n\tbox-shadow: 0 3px 15px 0 rgba(0,0,0,.25);\n}\n\n.cplp_pricing-ribbon h3 {\n\tcolor: #222;\n\tfont-weight:500;\n\tfont-size:14px;\n\ttext-transform:uppercase;\n}\n\n.cplp_pricing-ribbon-arrow {\n\tposition: absolute;\n\ttop: 115px;\n\tright: 112px;\n  width: 0; \n  height: 0; \n  border-top: 17px solid transparent;\n  border-bottom: 17px solid transparent; \n  border-right: 10px solid #fdfe80; \n}\n\n.cplp_table-left .cplp_pricing-details h2, .cplp_table-right .cplp_pricing-details h2 {\n\tfont-size: 21px;\n\tfont-weight: 500;\n\tcolor: #505050;\n\tmargin-bottom: 30px;\n}\n\n.cplp_table-left .cplp_pricing-details p, .cplp_table-right .cplp_pricing-details p {\n\tfont-size: 14px;\n\tfont-weight: 300;\n\tcolor: #505050;\n\tletter-spacing: 0.75px;\n\tline-height: 1.4;\n}\n\n.cplp_table-left .cplp_pricing-details ul, .cplp_table-right .cplp_pricing-details ul {\n\tmargin-top: 30px;\n\tmargin-bottom: 30px;\n\tpadding: 0;\n}\n\n\n.cplp_table-left .cplp_pricing-details li, .cplp_table-right .cplp_pricing-details li {\n\tfont-family: 'Montserrat';\n\tfont-size: 16px;\n\tfont-weight: 400;\n\tcolor: #505050;\n\tline-height: 1.4;\n\tmargin-bottom: 10px;\n}\n\n.cplp_pricing-section .cplp_table-left:hover, .cplp_pricing-section .cplp_table-right:hover {\n\tbox-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.1);\n\t-webkit-transition: 0.3s;\n\t-moz-transition: 0.3s;\n\t-o-transition: 0.3s;\n\ttransition: 0.3s;\n}\n\n.cplp_pricing-section .cplp_table-left, .cplp_pricing-section .cplp_table-right {\n\tmargin-top: 20px;\n\tbackground: #fafafa;\n\tmin-height: 575px;\n}\n/*\n.cplp_pricing-section .cplp_table-center {\n\tmargin-top: 0;\n}\n*/\n.cplp_pricing-section, .cplp_faq-feature, .faq {\n\tbackground: #eef2f5;\n}\n\n.cplp_core-price {\n\tmargin: auto;\n}\n\n.cplp_buy-price {\n\tcolor: #000000 !important;\n}\n\n.cplp_pricing-trial {\n\tmargin-top:15px;\n\tcolor:#999999;\n}\n\n.cplp_pricing-trial a {\n\tcolor:#333333;\n\ttext-decoration: underline;\n\tfont-weight:400;\n}\n\n.cplp_pricing-trial a:hover {\n\tcolor:#6c63ff;\n}\n\n.cplp_pricing-link {\n\tmargin-top:15px;\n}\n\n.cplp_pricing-link  a{\n\tcolor:#6c63ff;\n}\n\n.cplp_pricing-link  a:hover{\n\tcolor:#333;\n}\n\n/* The slider switch */\n.switch {\n  position: relative;\n  display: inline-block;\n  width: 60px;\n  height: 34px;\n  margin: 0 5px;\n}\n\n.switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.switch-label-sub {\n\tfont-size: 12px;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #6c63ff;\n  -webkit-transition: .4s;\n  transition: .4s;\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 26px;\n  width: 26px;\n  left: 4px;\n  bottom: 4px;\n  background-color: white;\n  -webkit-transition: .4s;\n  transition: .4s;\n}\n\n\ninput:focus + .slider {\n  box-shadow: 0 0 1px #2196F3;\n}\n\ninput:checked + .slider:before {\n  -webkit-transform: translateX(26px);\n  -ms-transform: translateX(26px);\n  transform: translateX(26px);\n}\n\n\n.slider.round {\n  border-radius: 34px;\n}\n\n.slider.round:before {\n  border-radius: 50%;\n}\n\n.monthly-price-base, .monthly-price-full, .monthly-price-pro {\n\tdisplay:none;\n}\n\n.annual-price-terms {\n\tfont-size: 11px!important;\n\tfont-weight: 400!important;\n\tletter-spacing: 0.5px!important;\n\tmargin-top:5px!important;\n\tcolor:#000!important;\n}\n\n.cplp_pricing-feature-txt {\n\tfont-family: 'Montserrat', Sans-serif!important;\n\tfont-size:16px!important;\n\t/* font-weight: 400!important; */\n\tcolor: #505050!important;\n\tline-height: 1.4!important;\n\tmargin-bottom: 10px!important;\n\tletter-spacing: 0.5px;\n}\n\n.cplp_pricing-features {\n\tmargin-top:25px;\n\tmin-height: 368px;\n}\n\n.cplp_pricing-features .row{\n\tclear: both;\n}\n\n.cplp_pricing-tier h2 {\n\tcolor:#fff!important;\n\tpadding-top: 20px;\n\tpadding-bottom: 20px;\n}\n\n.cplp_pricing-tier-1 {\n\tbackground: #3598dc;\n}\n\n.cplp_pricing-tier-2 {\n\tbackground: #e7505a;;\n}\n\n.cplp_pricing-tier-3 {\n\tbackground: #8e44ad;\n}\n\n.cplp_pricing-summary {\n\tmargin-top:15px;\n\tpadding: 0 20px;\n}\n\n\n\n\n/*-----------------------------------------------------\n------------ 10. f-box Section Styling ----------------\n-----------------------------------------------------*/\n\n\n.cplp_f-box {\n  width: 100%;\n  padding-top: 50px;\n  padding-bottom: 50px;\n\tbackground: #eef2f5;\n  background-size: cover;\n  background-attachment: fixed;\n}\n\n.cplp_f-box-single {\n  background: #fff;\n  padding: 1em 1em 0.5em 1em;\n\tmargin-top: 1em;\n\tmargin-bottom: 1em;\n\tborder-radius: 5px;\n\tborder: 1px solid rgba(0, 0, 0, .05);\n  -webkit-transition: 0.3s;\n  -moz-transition: 0.3s;\n  transition: 0.3s;\n}\n\n.cplp_f-box-single:hover {\n  background: #FFF;\n}\n\n.cplp_f-box-content h3 {\n  font-size: 18px;\n  letter-spacing: 0;\n  color: #364655;\n  font-weight: 500;\n}\n\n.cplp_f-box-content p {\n  font-size: 14px;\n  color: #616771;\n  line-height: 1.8;\n  padding: 1.2em;\n}\n\n@media only screen and (min-width: 801px) and (max-width: 991px) {\n  .cplp_f-box-single {\n    padding: 1em;\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .cplp_f-box-single {\n    margin-bottom: 1em;\n  }\n}\n\n@media only screen and (max-width:576px) {\n\t.navigation .container {\n\t\tmargin: 0;\n\t}\n}\n\n/*-----------------------------------------------------\n------------ 11. Client Section Styling --------------\n-----------------------------------------------------*/\n\n\n.cplp_client-section {\n\tbackground-color: #eef2f5;\n\tpadding: 25px 25px;\n\tborder: 1px solid #eef2f5;\n}\n\n.cplp_clients .cplp_single img {\n\twidth: 180px;\n\topacity: 0.75;\n}\n\n.cplp_clients {\n\ttext-align: center;\n}\n\n.cplp_clients-intro h1{\n\tmargin-bottom:20px;\n\tmargin-top:5px;\n\tfont-size:28px;\n\tcolor: #364655;\n\tfont-weight: 600;\n}\n\n\n/*-------------- 8. Review Section Styling ------------*/\n\n.section-r {\n\tmargin-top: 50px;\n\tmargin-bottom:25px;\n}\n\n.review-section {\n\tpadding: 0 0 0 0;\n\tbox-shadow: 0px 5px 50px 0px rgba(0,0,0,.1);\n\tmargin-bottom: 50px;\n\tborder-radius: 10px;\n}\n\n.review-section .review-text {\n\tmax-width: 85%;\n\tmargin: 0 auto;\n}\n\n.review-section .review-text p {\n\tfont-size: 18px;\n\tfont-weight: 400;\n\tline-height: 1.6;\n\tletter-spacing: 0.5px;\n\tcolor: #333333;\n\tmargin-bottom: 10px;\n}\n\n.review-section .review-text h3 {\n\tfont-size: 18px;\n\tfont-weight: 500;\n\tcolor: #000000;\n\tmargin-bottom: 10px;\n\tmargin-top: 20px;\n}\n\n.review-section .review-text h4 {\n\tfont-size: 14px;\n\tfont-weight: 400;\n\tcolor: #000000;\n}\n\n.review-single {\n\ttext-align: center;\n\tpadding: 50px 0 25px 0;\n}\n\n.review-single img {\n\twidth: 180px !important;\n\tmargin: 0 auto;\n\tmargin-bottom: 20px;\n}\n\n.review-text .ion {\n\tdisplay: inline-block;\n\tmargin-top: 20px;\n  font-size: 14px;\n  color: #ff8000;\n}\n\n.owl-theme .owl-dots {\n    display: none !important;\n}\n\n\n/*--------------------------------------------------------------\n---------------12. Footer Styling  -----------------------\n--------------------------------------------------------------*/\n\n\n.cplp_footer {\n\tpadding: 50px 0 50px 0;\n\tbackground: #333333;\n}\n\n.cplp_footer h2 {\n\tfont-size: 18px;\n\tfont-weight: 500;\n\tcolor: #FFFFFF;\n\tmargin-bottom: 10px;\n}\n\n.cplp_footer p {\n\tfont-size: 13px;\n\tfont-weight: 400;\n\tcolor: #364655;\n\tcolor: #FFF;\n\tletter-spacing: 0;\n\tline-height: 1.4;\n\tmax-width: 320px;\n\tmargin-bottom: 10px;\n}\n\n.cplp_footer .cplp_f-mail {\n\tmargin: 5px 5px 0 0;\n\tfont-family: 'Montserrat';\n\tfont-size: 13px;\n\tletter-spacing: 0;\n\tcolor: #364655;\n\tcolor: #D8D8D8;\n\tline-height: 1.6;\n}\n\n.cplp_footer .cplp_f-legal {\n\tmargin: 5px 5px 0 10px;\n\tfont-family: 'Montserrat';\n\tfont-size: 15px;\n\tletter-spacing: 0;\n\tcolor: #bbbbbb;\n\tline-height: 1.6;\n}\n\n.cplp_footer .cplp_f-legals {\n\tfont-size: 15px;\n\tcolor: #bbbbbb;\n\tpadding-top:20px;\n}\n\n.cplp_footer .cplp_footer-logo {\n\tmargin-bottom:10px;\n}\n\n/* ------------Back-to-Top ----------------------*/\n\n.back-to-top {\n\tbackground: rgba(68, 176, 255, 0.5);\n\tmargin: 0;\n\tposition: fixed;\n\tbottom: 30px;\n\tright: 30px;\n\twidth: 40px;\n\theight: 40px;\n\tborder-radius: 3px;\n\tz-index: 90;\n\tdisplay: none;\n\ttext-decoration: none;\n\tcolor: #0E1729;\n\tbox-shadow:0 5px 10px rgba(0, 0, 0, .3);\n}\n\n.back-to-top i {\n\tposition: relative;\n\tleft: 12px;\n\ttop: 5px;\n\tfont-size: 24px;\n\tcolor: #FFFFFF;\n\t-webkit-transition: 200ms;\n\t-moz-transition: 200ms;\n\t-o-transition: 200ms;\n\ttransition: 200ms;\n}\n\n.back-to-top:hover {\n\tbackground: rgba(68, 176, 255, 0.8);\n  color: #FFFFFF;\n}\n\n.back-to-top:hover i {\n\ttop: 6px;\n}\n\n.back-to-top:focus {\n    color: #FFFFFF;\n}\n\n\n\n/*-----------------------------------------------------------------\n------------------ 13. All Media Queries  -------------------------\n-----------------------------------------------------------------*/\n\n@media only screen and (min-width: 767px) {\n\n\t.navbar-nav {\n\t\t\tmargin-top: 0;\n\t\t}\n\n\t.navbar-nav .nav-item {\n\t\tmargin-top: 0;\n\t\tmargin-right: 15px;\n\t  font-size: 0.85rem;\n\t  font-weight: 400;\n\t}\n\n\t.cplp_home-2 {\n\t\tpadding: 100px 0 60px 0 !important;\n\t}\n\n\t.cplp_home-2 .col-sm-5 {\n\t\t-webkit-box-flex: 0;\n\t\t-webkit-flex: 0 0 50%;\n\t\t-ms-flex: 0 0 50%;\n\t\tflex: 0 0 50%;\n\t\tmax-width: 50%;\n\t}\n\n\t.features {\n\t\tpadding: 75px 0 50px 0;\n\t}\n\n\t.features .col-sm-5 {\n\t\t-webkit-box-flex: 0;\n\t\t-webkit-flex: 0 0 41.666667%;\n\t\t-ms-flex: 0 0 41.666667%;\n\t\tflex: 0 0 41.666667%;\n\t\tmax-width: 41.666667%;\n\t}\n\n\t.features .col-sm-7 {\n\t\t-webkit-box-flex: 0;\n\t\t-webkit-flex: 0 0 58.333333%;\n\t\t-ms-flex: 0 0 58.333333%;\n\t\tflex: 0 0 58.333333%;\n\t\tmax-width: 58.333333%;\n\t}\n\n\t.features .feature-img {\n\t\tmargin-bottom: 0;\n\t}\n\n\t.cplp_product-tour .cplp_tour-intro {\n\t\tpadding: 0;\n\t}\n\n\t.cplp_product-tour .cplp_tour-img {\n\t\ttransform: translateX(120px);\n\t}\n\n\t.cplp_product-tour .cplp_tour-img {\n\t\ttransform: translateX(0);\n\t\tmax-width: 100%;\n\t}\n\n\t.cplp_clients .cplp_single img {\n\t\twidth: 180px;\n\t\topacity: 0.75;\n\t}\n\t\n\t.vid-cover iframe {\n\twidth: 100%;\n\tmin-height: 380px;\n}\n\n}\n\n\n@media only screen and (min-width: 1024px) {\n\n\t.cplp_home-2 img {\n\t\tmargin-top: 0;\n\t}\n\n\t.cplp_home-2 .cplp_hero-content {\n\t\ttext-align: left;\n\t}\n\n\t.cplp_product-tour .cplp_tour-intro h1 {\n\t\tfont-size: 28px;\n\t}\n\n\t.cplp_product-tour .cplp_tour-img {\n\t\ttransform: translateX(80px);\n\t\tmax-width: 100%;\n\t}\n\n}\n\n@media only screen and (max-width: 992px) {\n\n\t.cplp_nav-phone {\n\t\tdisplay:none;\n\t}\n\n\t.cplp_pricing-ribbon {\n\t\ttop: 115px;\n\t\tright: 150px;\n\t}\n\t\n\t.cplp_pricing-ribbon-arrow {\n\t\ttop: 115px;\n\t\tright: 252px;\n\t}\n\n}\n\n@media only screen and (max-width: 550px) {\n\n\t.cplp_pricing-ribbon {\n\t\ttop: 115px;\n\t\tright: 40px!important;\n\t}\n\t\n\t.cplp_pricing-ribbon-arrow {\n\t\ttop: 115px;\n\t\tright: 142px!important;\n\t}\n\n}\n\n@media only screen and (max-width: 350px) {\n\t\n\t.vid-cover iframe {\n\t\twidth: 100%;\n\t\tmin-height: 165px;\n\t}\n\t\n}\n\n@media only screen and (min-width: 351px) {\n\t\n\t.vid-cover iframe {\n\t\twidth: 100%;\n\t\tmin-height: 260px;\n\t}\n\t\n}\n\n@media only screen and (min-width: 761px) {\n\t\n\t.vid-cover iframe {\n\t\twidth: 100%;\n\t\tmin-height: 375px;\n\t}\n\t\n}\n\n@media only screen and (min-width: 975px) {\n\t\n\t.vid-cover iframe {\n\t\twidth: 100%;\n\t\tmin-height: 298px;\n\t}\n\t\n}\n\n@media only screen and (min-width: 1182px) {\n\t\n\t.vid-cover iframe {\n\t\twidth: 100%;\n\t\tmin-height: 355px;\n\t}\n\t\n}\n\n@media only screen and (max-width: 1200px) {\n\t\n\t.cplp_pricing-feature-txt {\n\t\tfont-size: 12px!important;\n\t}\n\n\t.cplp_nav-phone {\n\t\tfont-size: 13px;\n\t}\n\t\n}\n\n\n@media only screen and (max-width: 767px) {\n\n\t.cplp_product-tour .cplp_tour-img {\n\t\ttransform: translateX(0);\n\t\tmax-width: 100%;\n\t}\n\t\n\t.cplp_navbar-right {\n\t\tpadding-bottom: 30px;\n\t}\n\t\n\t.cplp_home-2 {\n\t\tpadding: 150px 0 50px 0 !important;\n\t}\n\t\n\t.navbar-nav {\n\t\tflex-direction: row;\n\t\tmargin-top:0;\n\t}\n\t\n\t.navbar-nav .nav-item {\n\t\tmargin-right: 7px;\n\t\tmargin-top: 0;\n\t}\n\t\n\t.navbar-nav .nav-item  .nav-link {\n\t\tfont-size: 10px;\n\t}\n\t\n\t.navbar .navbar-toggler {\n\t\tdisplay: none;\n\t}\n\t\n\t.navbar .cplp_navbar-right {\n\t\tpadding-bottom: 0;\n\t}\n\t\n\t.header-logo {\n\t\tmax-width:150px;\n\t}\n\t\n\t.cplp_pricing-ribbon {\n\t\ttop: 115px;\n\t\tright: 65px;\n\t}\n\t\n\t.cplp_pricing-ribbon-arrow {\n\t\ttop: 115px;\n\t\tright: 167px;\n\t}\n}\n /*----------------------------------------------------------\n--------------- 3. Login Page Styling  ----------------------\n----------------------------------------------------------*/\n\n    .cplp_login-body {\n        background: #2e7eed;\n    }\n\n    .cplp_login-section h4 {\n        font-family: 'Open Sans';\n        font-size: 24px;\n        font-weight: 700;\n        color: #eeeeee;\n        text-transform: uppercase;\n        line-height: 1.2;\n        letter-spacing: 2px;\n        margin-bottom: 20px;\n    }\n\n    .cplp_login-section h1 {\n        font-size: 28px;\n        font-weight: 700;\n        color: #364655;\n        /* color: #FFF; */\n        line-height: 1.2;\n        letter-spacing: -1px;\n    }\n\n    .cplp_login-section p {\n        font-size: 16px;\n        font-weight: 300;\n        color: #627382;\n        /* color: #FFF; */\n        line-height: 1.6;\n        letter-spacing: 1px;\n        margin-top: 20px;\n    }\n\n    .cplp_login-section {\n        font-family: 'Open Sans';\n        padding: 100px 0 50px 0 !important;\n        background:rgb(245, 250, 255);\n    }\n\n    .cplp_login-intro h1 {\n        margin-bottom: 10px;\n    }\n\n    .cplp_login-intro h2 {\n        font-size: 22px;\n        font-weight: 700;\n        color: #364655;\n        /* color: #FFF; */\n        line-height: 1.2;\n        letter-spacing: -1px;\n        margin-bottom: 30px;\n    }\n\n    .cplp_login-section .cplp_login-intro {\n        text-align: center;\n    }\n\n    .cplp_login-section {\n        width: 100%;\n    }\n\n    .cplp_login-submit {\n        text-align: center;\n        margin-top: 20px;\n    }\n\n    .cplp_login-remember {\n        text-align: left;\n        margin-top: 20px;\n        color: #fff;\n    }\n\n    .cplp_login-forgot {\n        text-align: right;\n        margin-top: 20px;\n        color: #364655;\n    }\n\n    .cplp_login-create {\n        text-align: center;\n        margin-top: 30px;\n        color: #364655;\n    }\n\n        .cplp_login-forgot a, .cplp_login-activate a, .cplp_login-create a {\n            color: #364655;\n        }\n\n    .cplp_login-footer {\n        text-align: center;\n    }\n\n        .cplp_login-footer p {\n            font-family: 'Open Sans';\n            font-size: 12px;\n            margin-top: 10px;\n        }\n\n    .cplp_login-divider {\n        color: #364655;\n        border-top: 1px solid rgba(255,255,255,.2);\n        margin: 50px 0;\n    }\n\n    .cplp_login-logo {\n        max-width: 150px;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
